import { render, staticRenderFns } from "./LotteryTask.vue?vue&type=template&id=58a4f0ce&scoped=true&"
import script from "./LotteryTask.vue?vue&type=script&lang=js&"
export * from "./LotteryTask.vue?vue&type=script&lang=js&"
import style0 from "./LotteryTask.vue?vue&type=style&index=0&id=58a4f0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a4f0ce",
  null
  
)

export default component.exports